'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".InputButton-module_button__fda-x{background-color:#1399d6;border:none;border-radius:1.25rem;height:2rem;padding:0;width:2rem}.InputButton-module_button__fda-x.InputButton-module_disabled__qnUpz{background-color:#424242}.InputButton-module_svg__MR1Mb{height:1.25rem;width:1.25rem}";
var styles = {"button":"InputButton-module_button__fda-x","disabled":"InputButton-module_disabled__qnUpz","svg":"InputButton-module_svg__MR1Mb"};
styleInject["default"](css_248z, '4691c369-57e3-4545-972a-35ac1f6c0b3d');

exports["default"] = styles;
